import { gql } from "@apollo/client"

export const GET_USERS = gql`
  query Users($staff_id: ID!, $organization_id: ID!) {
    users(staff_id: $staff_id, organization_id: $organization_id) {
      staff_id
      staff_alias
      staff_user_status
      staff_name_first
      staff_name_last
      staff_email_address
      staff_role_name
      organization_id
      organization_alias
    }
    participants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "all_participants"
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_phone_primary
      participant_membership_status
    }
  }
`

export const GET_SERVICES = gql`
  query getTemplatesByOrganization(
    $organization_id: ID!
    $template_type: String
  ) {
    getTemplatesByOrganization(
      organization_id: $organization_id
      template_type: $template_type
    ) {
      template_title
      template_name
      template_collection
      template_type
      template_availability
    }
  }
`

export const GET_PARTICIPANTS = gql`
  query Users($staff_id: ID!, $organization_id: ID!) {
    participants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "all_participants"
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_primary
      participant_phone_primary
      participant_membership_status
    }
  }
`
